<app-feature-hero
    title="Get More from Your Software with Smart Asset Management"
    description="Streamline operations with Infraon’s <br> software asset management solutions"
    image="/assets/img/feature-pages/infraon-assets/sam/hardware-hero-img-01-01.svg"
    imageAlt="Software Asset Management Hero Image"
></app-feature-hero>

<app-feature-row
    headingLevel="h2"
    heading="What Is Software Asset Management (SAM)?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-1.webp"
    imageAlt="What Is Software Asset Management (SAM)?"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Infraon’s Software Asset <br /> Management Solution"
    [paragraphs]="solutionParagraphs"
    image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-2.webp"
    imageAlt="Infraon’s Software Asset Management Solution"
    imagePosition="left"
></app-feature-row>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing container">
    <div
        class="ai-based-itsm depreciation-calculator case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Use A Software <br />
                Asset Depreciation Calculator
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Improve financial planning through accurate depreciation measurement
                – support <br />
                informed asset management decisions.
            </p>

            <a routerLink="/free-tools/asset-depreciation-calculator/" class="calculator-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Calculate</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                    <path
                        d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
                        fill="#1A5AD9" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">
        Key Features of Infraon’s Software <br />
        Asset Management Solution
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                    <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
                    <path
                        d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
                        fill="#084CD4" />
                    <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Automated Software Discovery
                </h3>
                <p class="section-paragraph-s text-start">
                    Automate scanning of software assets with a rapid-fire
                    “scan/search” feature for endpoints. Resolve any hindrances to
                    asset governance.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="0 0 34 30" fill="none">
                    <rect x="12" y="6" width="10" height="24" fill="#A8C1F1" />
                    <path
                        d="M17.0332 0C17.9638 0 18.828 0.535714 19.2933 1.33929L33.651 25.9821C34.1163 26.8527 34.1163 27.8571 33.651 28.6607C33.1857 29.5312 32.3216 30 31.391 30H2.67546C1.6784 30 0.814272 29.5312 0.348974 28.6607C-0.116325 27.8571 -0.116325 26.8527 0.348974 25.9821L14.7067 1.33929C15.172 0.535714 16.0362 0 17.0332 0ZM17.0332 8.57143C16.1026 8.57143 15.4379 9.30804 15.4379 10.1786V17.6786C15.4379 18.6161 16.1026 19.2857 17.0332 19.2857C17.8974 19.2857 18.6285 18.6161 18.6285 17.6786V10.1786C18.6285 9.30804 17.8974 8.57143 17.0332 8.57143ZM19.1603 23.5714C19.1603 22.433 18.1632 21.4286 17.0332 21.4286C15.8368 21.4286 14.9062 22.433 14.9062 23.5714C14.9062 24.7768 15.8368 25.7143 17.0332 25.7143C18.1632 25.7143 19.1603 24.7768 19.1603 23.5714Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Software License Management
                </h3>
                <p class="section-paragraph-s text-start">
                    Track any overflow in your software asset license usage – anytime
                    and anyplace. Easily avoid any issues related to unused software
                    asset licenses.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Software Whitelisting and Blacklisting
                </h3>
                <p class="section-paragraph-s text-start">
                    Use a software whitelisting and blacklisting system to prevent
                    future threats. Minimize the damage caused by existing breaches in
                    a few steps.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="29" viewBox="0 0 16 29" fill="none">
                    <path
                        d="M9.31251 4.54688C10.7891 4.71094 12.1563 4.98438 13.1953 5.20312C13.9063 5.42188 14.3438 6.07812 14.1797 6.78906C14.0156 7.5 13.3047 7.9375 12.5938 7.77344C10.8984 7.39062 8.43751 6.89844 6.35938 7.11719C5.32032 7.17188 4.50001 7.39062 3.89845 7.77344C3.35157 8.15625 2.91407 8.64844 2.8047 9.46875C2.64063 10.0703 2.75001 10.5078 2.91407 10.7812C3.02345 11.1094 3.35157 11.4375 3.84376 11.7109C4.88282 12.3672 6.41407 12.8047 8.27345 13.2422L8.43751 13.2969C10.1328 13.7344 12.0469 14.2266 13.5234 15.1016C14.2891 15.5938 14.9453 16.1953 15.3828 17.0703C15.875 17.9453 15.9297 18.9844 15.7656 20.0781C15.3828 22.0469 13.9609 23.3047 12.2109 23.9609C11.3359 24.2891 10.3516 24.5078 9.31251 24.5625V27.1875C9.31251 27.9531 8.71095 28.5 8.00001 28.5C7.23438 28.5 6.68751 27.9531 6.68751 27.1875V24.5078C6.46876 24.4531 6.3047 24.4531 6.14063 24.4531L6.08595 24.3984C4.77345 24.2344 2.3672 23.6875 0.890634 23.0312C0.234384 22.7031 -0.0937407 21.9375 0.234384 21.2812C0.507822 20.625 1.27345 20.2969 1.9297 20.625C3.07813 21.1172 5.26563 21.6641 6.46876 21.8281C8.43751 22.1016 10.0781 21.9375 11.2813 21.5C12.4297 21.0625 13.0313 20.4062 13.1406 19.5859C13.3047 18.9297 13.1953 18.5469 13.0313 18.2734C12.9219 17.9453 12.5938 17.6172 12.1016 17.3438C11.0625 16.6875 9.53126 16.25 7.67188 15.8125L7.50782 15.7578C5.81251 15.3203 3.89845 14.8281 2.42188 13.9531C1.65626 13.4609 1.00001 12.8594 0.562509 11.9844C0.0703218 11.0547 0.0156343 10.0703 0.179697 8.97656C0.507822 7.39062 1.32813 6.29688 2.47657 5.58594C3.57032 4.875 4.88282 4.60156 6.14063 4.49219C6.3047 4.49219 6.46876 4.4375 6.68751 4.4375V1.8125C6.68751 1.10156 7.23438 0.5 8.00001 0.5C8.71095 0.5 9.31251 1.10156 9.31251 1.8125V4.54688Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Software True-Up Costs
                </h3>
                <p class="section-paragraph-s text-start">
                    Be ready to report the true-up cost of your software assets,
                    including license and maintenance. Ensure accuracy to prevent bad
                    decisions.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path
                        d="M18.375 19.25C17.3359 19.25 16.3516 19.1406 15.4219 18.8125L13.6172 20.6172C13.3438 20.8906 13.0156 21 12.6875 21H10.5V23.1875C10.5 23.9531 9.89844 24.5 9.1875 24.5H7V26.6875C7 27.4531 6.39844 28 5.6875 28H1.3125C0.546875 28 0 27.4531 0 26.6875V22.3125C0 21.9844 0.109375 21.6562 0.382812 21.3828L9.1875 12.5781C8.85938 11.6484 8.75 10.6641 8.75 9.625C8.75 4.32031 13.0156 0 18.375 0C23.6797 0 28 4.32031 28 9.625C28 14.9844 23.6797 19.25 18.375 19.25ZM20.5625 9.625C21.7656 9.625 22.75 8.69531 22.75 7.4375C22.75 6.23438 21.7656 5.25 20.5625 5.25C19.3047 5.25 18.375 6.23438 18.375 7.4375C18.375 8.69531 19.3047 9.625 20.5625 9.625Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Software Access Control
                </h3>
                <p class="section-paragraph-s text-start">
                    Gain control with the least privilege access privileges to assets
                    with authentication and authorization protocols. Stay clear of
                    compliance risks.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none">
                    <path
                        d="M31.75 3.5V7.875C30.2734 7.875 29.125 9.07812 29.125 10.5C29.125 11.9766 30.2734 13.125 31.75 13.125V17.5C31.75 19.4688 30.1641 21 28.25 21H3.75C1.78125 21 0.25 19.4688 0.25 17.5V13.125C1.67188 13.125 2.875 11.9766 2.875 10.5C2.875 9.07812 1.67188 7.875 0.25 7.875V3.5C0.25 1.58594 1.78125 0 3.75 0H28.25C30.1641 0 31.75 1.58594 31.75 3.5Z"
                        fill="#084CD4" />
                    <path
                        d="M7 6.75C7 5.82031 7.76562 5 8.75 5H22.75C23.6797 5 24.5 5.82031 24.5 6.75V13.75C24.5 14.7344 23.6797 15.5 22.75 15.5H8.75C7.76562 15.5 7 14.7344 7 13.75V6.75ZM21.875 7.625H9.625V12.875H21.875V7.625Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start my-3">
                    Integrated Ticketing
                </h3>
                <p class="section-paragraph-s text-start">
                    Centralize IT ticket management with an inbuilt integrated system
                    that offers multi-channel support. Get self-service options, such
                    as chatbot capabilities.
                </p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Other Features of Infraon’s Software Asset Management Solution"
    listStyle="check"
    checkIconSize="lg"
    [listItems]="otherFeaturesItems"
    image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-10.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm ebook d-flex align-items-center justify-content-between primary-bg position-relative">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                2026 and Beyond: IT Asset <br />
                Management Trends
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Discover how technological advancements are transforming IT asset
                <br />
                management and secure your organization’s future.
            </p>

            <a [routerLink]="['/resources', 'ebook', 'itops-technology-trends-2023']" class="crmform-button">
                <span class="me-1">Download our e-book</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0d51d9" />
                </svg>
            </a>
        </div>
        <img loading="lazy"
            src="/assets/img/feature-pages/asset-management-ebook.webp"
            class="asset-mmanagement-ebook m-d-none" alt="asset mmanagement ebook" />
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">
        Discover how technological advancements are transforming <br />
        IT asset management and secure your organization’s future.
    </h2>

    <app-feature-row
        headingLevel="h3"
        heading="Software Asset Acquisition"
        [paragraphs]="acquisitionParagraph"
        listStyle="plain"
        [listItems]="acquisitionItems"
        image="/assets/img/feature-pages/infraon-assets/sam/barcode-feature-img-4-01.webp"
        imageAlt="Infraon Assets Dashboard"
        imagePosition="right"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Software Asset Installation"
        [paragraphs]="installationParagraph"
        listStyle="plain"
        [listItems]="installationItems"
        image="/assets/img/feature-pages/infraon-assets/sam/sam-feature-image-7.svg"
        imageAlt="Software Asset Installation"
        imagePosition="left"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Software Asset Usage"
        [paragraphs]="usageParagraph"
        listStyle="plain"
        [listItems]="usageItems"
        image="/assets/img/feature-pages/infraon-assets/sam/qr-code-feature-img-2-01.png"
        imageAlt="Device discovery charts"
        imagePosition="right"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Software Asset Audit and Compliance"
        [paragraphs]="auditParagraph"
        listStyle="plain"
        [listItems]="auditItems"
        image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-4.webp"
        imageAlt="Asset Audit"
        imagePosition="left"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Software Asset Disposal"
        [paragraphs]="disposalParagraph"
        listStyle="plain"
        [listItems]="disposalItems"
        image="/assets/img/feature-pages/infraon-assets/sam/infinity-feature-img1.webp"
        imageAlt="Infraon Asset Dashboard"
        imagePosition="right"
    ></app-feature-row>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">CASE STUDY</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                How a Global IT Consulting Company Benefited from Infraon’s Asset
                Management Software
            </h2>
            <div class="case-study-pointers">
                <div>
                    <span></span>
                    <span>75% improved asset efficiency</span>
                </div>
                <div>
                    <span></span>
                    <span>50%-75% lesser asset spend</span>
                </div>
                <div>
                    <span></span>
                    <span>75% more asset compliance</span>
                </div>
            </div>

            <a [routerLink]="['/resources', 'case-studies', 'tcs-passport-seva-project']" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Download Case-study</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0d51d9" />
                </svg>
            </a>
        </div>
        <div>
            <img loading="lazy" src="/assets/img/feature-pages/case-study-illustration.webp"
                class="case-study-illustration m-d-none" alt="Case Study Illurtation" />
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Best Practices for Managing IT Software Assets"
    [paragraphs]="bestPracticesParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="bestPracticesItems"
    image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-5.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Benefits of IT Software Asset Management"
    [paragraphs]="benefitsParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="benefitsItems"
    image="/assets/img/feature-pages/infraon-assets/sam/ham-feature-image-6.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="right"
></app-feature-row>

<app-faqs [faqs]="faqs" [theme]="'assets-theme'"></app-faqs>